import React, { Component } from 'react';
import $ from 'jquery';
import DataTablesCreate from "./DataTablesCreate";

let headers = [
    { title: 'Placa' },
    { title: 'Código Unidad' },
    { title: 'Sucursal' },
    { title: 'Almacén' },
];

class ORDRTransportsModal extends Component {

    componentDidMount() {
        this.closeAction();
    }

    closeORDRTransportsModal = async () => {
        $('#ordrTransportsModal').modal('hide');
    }

    closeAction = () => {
        const { cleanData } = this.props;
        $('#ordrTransportsModal').on('hidden.bs.modal', function () {
            cleanData();
        });
    };

    render() {
        const { selectORDRTransport, data = [] } = this.props;

        return (
            <div>
                <div className="modal fade bd-example-modal-lg modal-open scroll" role="dialog" id="ordrTransportsModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-open" role="document" >
                        <div className="modal-content">

                            <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                                <h4 className="modal-title" id="modal-basic-title ">Transportes</h4>
                                <button type="button" className="close" onClick={this.closeORDRTransportsModal} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body" >
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div className="w-100 table-scroll tab-pane fade show active " aria-labelledby="nav-home-tab-Contenido" >
                                                <table className="table response" style={{ marginBottom: 0, height: 570, maxHeight: 570 }}>
                                                    <tbody>
                                                        <DataTablesCreate
                                                            headers={headers}
                                                            data={data}
                                                            view={"ORDRTransports"}
                                                            action={selectORDRTransport}
                                                        />
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeORDRTransportsModal}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ORDRTransportsModal;